import { PropertySpaceRange } from '@immosky/types';
import { createAction, props } from '@ngrx/store';

export enum PropertySpaceActions {
  Reset = '[Filter] Reset Property Space Filter',
  Set = '[Filter] Set Property Space Filter',
  SetBasedOnValues = '[Filter] Set Property Space Filter Based On Values',
}

export const resetPropertySpaceFilter = createAction(
  PropertySpaceActions.Reset
);

export const setPropertySpaceFilter = createAction(
  PropertySpaceActions.Set,
  props<{ filter: PropertySpaceRange }>()
);

export const setPropertySpaceFilterBasedOnUrlValues = createAction(
  PropertySpaceActions.SetBasedOnValues,
  props<{ values: { min: number; max: number } }>()
);
